module.exports = __webpack_public_path__ + "static/media/m3-STRETCH_AND_MOVE.054a4b2e.png";